import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-quick-stats',
	templateUrl: './quick-stats.component.html',
	styleUrls: ['./quick-stats.component.css'],
})
export class QuickStatsComponent implements OnInit {
	@Input() iconClass: string = 'fa-none';
	@Input() statValue: number = 0;
	@Input() statDescription: string;
	@Input() isLoading: boolean = true;
	@Input() iconImage: boolean = false;

	constructor() {}

	ngOnInit(): void {}
}
